import ajax from "@/utils/ajax";
import utils from "@/utils";
export default {


    // //分类列表
    // classify:(data)=>{
    //     data = utils.dealParam(data)
    //     return ajax.post('rightscreen/classify',data || {})
    // },
    // //分类列表
    // jurisdiction:(data)=>{
    //     data = utils.dealParam(data)
    //     return ajax.post('rightscreen/jurisdiction',data || {})
    // },
    // //右侧大屏配置列表接口
    // screenList:(data)=>{
    //     data = utils.dealParam(data)
    //     return ajax.post('rightscreen/list',data || {})
    // },
    // //右侧大屏配置编辑接口
    // screenEdit:(data)=>{
    //     data = utils.dealParam(data)
    //     return ajax.post('rightscreen/edit',data || {})
    // },
    // //右侧大屏配置详情接口
    // listInfo:(data)=>{
    //     data = utils.dealParam(data)
    //     return ajax.post('rightscreen/info',data || {})
    // },
    // //右侧大屏配置删除接口
    // deleteInfo:(data)=>{
    //     data = utils.dealParam(data)
    //     return ajax.post('rightscreen/delete',data || {})
    // },
    // //页面信息接口
    // indexInfo:(data)=>{
    //     data = utils.dealParam(data)
    //     return ajax.post('rightscreen/indexinfo',data || {})
    // },
    // //页面信息修改接口
    // indexEdit:(data)=>{
    //     data = utils.dealParam(data)
    //     return ajax.post('rightscreen/indexedit',data || {})
    // },
    // //百分比统计接口
    // getPieInfo:(data)=>{
    //     data = utils.dealParam(data)
    //     return ajax.post('rightscreen/statistics',data || {})
    // },

  //登录
  login:(data)=>{
    data = utils.dealParam(data)
    return ajax.post('https://zjvrtournament.zjfazhi.com/api/auth/login',data || {})
  },

  getUserInfo:(data)=>{
    // data = utils.dealParam(data)
    // return ajax.get('https://zjvr.zjfazhi.com/api/auth/info',data || {})


    return ajax({
      url: 'https://zjvrtournament.zjfazhi.com/api/auth/info',
      type: 'get',
      headers: {
        "Authorization":data,
        //'Content-Type': 'application/json'  //application/x-www-form-urlencoded  application/json
      }
    });
  },
    //新接口
    //题目列表接口
    getExamList:(data)=>{
        data = utils.dealParam(data)
        return ajax.post('exam/list',data || {})
    },

    //排行详情接口
    getphInfo:(data)=>{
        data = utils.dealParam(data)
        return ajax.post('paihang/info',data || {})
    },
    //理论成绩提交接口
    startExam:(data)=>{
        data = utils.dealParam(data)
        return ajax.post('exam/start',data || {})
    },
    //理论成绩提交接口
    addlilun:(data)=>{
        data = utils.dealParam(data)
        return ajax.post('score/addlilun',data || {})
    },
    //vr结束答题
    examEnd:(data)=>{
        data = utils.dealParam(data)
        return ajax.post('exam/end',data || {})
    },
}



// WEBPACK FOOTER //
// ./src/utils/api.js